import styled from "@emotion/styled";
import { Col, Form, Input, Popconfirm } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InfoCircleOutlined } from "@ant-design/icons";
import React from "react";

const ProductRecommendForm = () => {
  return (
    <FormWrapper>
      <div style={{ height: 10, marginBottom: 16 }}>
        <p style={{ fontSize: 14, fontWeight: 500 }}>เครื่องมือสื่อสาร (Media Kit)</p>
      </div>
      <Form.Item
        label="  ลิงค์วีดีโอแนะนำ"
        name="video_url"
        //rules={[{ required: is_active, message: "กรุณากรอกลิงค์วีดีโอแนะนำการขาย" }]}
        style={{ marginLeft: 16 }}

      >
        <Input
          placeholder="ลิงค์วีดีโอแนะนำ"
          // showCount
          // maxLength={120}
          size="small"
        />
      </Form.Item>
      {/* ยกเลิก field นี้ไปใช้ คำแนะนำสำคัญ
      <Form.Item
        label="คำแนะนำสำหรับตัวแทน"
        name="recomended_retail"
        // rules={[{ required: true, message: "กรุณากรอกชื่อสินค้า" }]}
        tooltip={{
          title: <TooltipContent />,
          icon: <InfoCircleOutlined />,
          color: "#ffffff",
        }}
      >
        <TextArea
          placeholder="คำแนะนำสำหรับตัวแทน"
          showCount
          maxLength={5000}
          rows={4}
        />
      </Form.Item>*/}
    </FormWrapper>
  );
};

const TooltipContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <h6 style={{ color: "black" }}>หมายเหตุ</h6>
      <p style={{ color: "black" }}>
        1. คำแนะนำสำหรับตัวแทน - คือคำแนะนำต่างๆ เช่นจุดเด่นของสินค้า
        ร้านค้าที่เหมาะสมให้ไปนำเสนอขาย หรือคำแนะนำอื่นๆ เป็นต้น
        เพื่อให้ตัวแทนสามารถนำคำแนะนำเหล่านี้ไปสื่อสารต่อกับร้านค้า
        และสามารถทำให้ ตัวแทนปิดการขายได้เร็วขึ้น{" "}
      </p>
      <p style={{ color: "black" }}>
        2. คำแนะนำสำหรับตัวแทน จะแสดงให้เห็นเฉพาะตัวแทนเท่านั้น
      </p>
    </div>
  );
};

export default ProductRecommendForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  margin-bottom: 10px;
  border-radius: 8px;
`;
